<div class="modal-header">
  <h5 class="modal-title" id="modal-basic-title">
    {{ data?.isEdit ? "Update" : "Import" }} Product
  </h5>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="modal.dismiss('')"
  >
    <span aria-hidden="true">Close</span>
  </button>
</div>

<div class="modal-body container" ngbAutofocus>
  <app-dc-file-upload
    [allowMultipleFiles]="!data?.isEdit"
    [autoLoad]="false"
    [acceptedFiles]="data.isEdit ? '.json,.xml' : '.csv,.json,.xml'"
    (filesChanged)="processDone = false"
    maxFileSize="6000000000"
  >
  </app-dc-file-upload>
</div>

<div class="modal-footer">
  <button
    class="btn btn-outline-primary"
    (click)="importFiles()"
    [disabled]="
      !fileUploader?.files.length ||
       fileUploader.errors.length ||
       fileUploader.uploadInProgress ||
       (processDone && !fileUploader.uploadInProgress)"
  >
    {{ data?.isEdit ? "Update Product" : "Import Files" }}
  </button>
</div>
